import React, { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import * as styles from './empty-state.style';

export type EmptyStateProps = {
  descriptionMessage?: FormattedMessage.MessageDescriptor;
  descriptionProps?: object;
  headingMessage: FormattedMessage.MessageDescriptor;
  headingProps?: object;
  imageSrc?: string;
  plainDescription?: string;
  children?: any;
};

export default class EmptyState extends PureComponent<EmptyStateProps> {
  render() {
    const {
      headingMessage,
      headingProps,
      descriptionMessage,
      descriptionProps,
      imageSrc,
      plainDescription,
      children,
    } = this.props;

    const image = imageSrc ? (
      <styles.ImageContainer>
        <img alt="" src={imageSrc} role="presentation" />
      </styles.ImageContainer>
    ) : null;

    return (
      <styles.Centered>
        {image}
        <styles.Heading>
          <FormattedMessage {...headingMessage} {...headingProps} />
        </styles.Heading>
        <styles.Description>
          {plainDescription ||
            (descriptionMessage && (
              <FormattedMessage {...descriptionMessage} {...descriptionProps} />
            ))}
        </styles.Description>
        {children}
      </styles.Centered>
    );
  }
}
